export const breadcrumbSchema = ({ breadcrumbs }) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs?.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.text,
      item: `https://www.bakcell.com/${crumb.slug}`,
    })),
  };
  return JSON.stringify(schema);
};
